import React, {Children, PropTypes, cloneElement, isValidElement} from 'react';
import styleComponent from './CustomList.scss';

export class CustomList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.arrayOf(PropTypes.node).isRequired
  };

  render() {
    const {className, style, children} = this.props;
    return (
      <div className={[styleComponent.list, className].join(' ')} style={style}>
        {Children.map(children, (child) => {
          return isValidElement(child) ? (
            cloneElement(child)
          ) : child;
        })}
      </div>
    );
  }
}

export default CustomList;



// WEBPACK FOOTER //
// ./src/components/common/CustomList/CustomList.js